import createReactClass from 'create-react-class';

import AnswerPanelTable from './AnswerPanelTable.js';
import UserRatingButton from './UserRatingButton.js';
import $ from 'jquery';
import PropTypes from 'prop-types';

const AnswerPanel = createReactClass({
  propTypes: {
    question: PropTypes.string.isRequired,
    result: PropTypes.object.isRequired,
    logId: PropTypes.number.isRequired,
    cgId: PropTypes.string.isRequired,
    enableUserRating: PropTypes.bool.isRequired,
    ratingAnswerRequired: PropTypes.bool.isRequired,
    gotoQACandidatePanel: PropTypes.func.isRequired,
    askQuestion: PropTypes.func.isRequired,
    generateAlert: PropTypes.func.isRequired,
    enableRatingReason: PropTypes.bool.isRequired,
    ratingReasonMsg: PropTypes.string.isRequired,
    ratingReasons: PropTypes.array.isRequired
  },

  getInitialState() {
    return {deleteModal: false};
  },

  openDeleteModal() {
    this.setState({deleteModal: true});
  },

  closeDeleteModal() {
    this.setState({deleteModal: false});
  },

  render: function () {
    let question = this.props.question;
    const result = this.props.result;
    const logId = this.props.logId;
    const cgId = this.props.cgId;
    const enableUserRating = this.props.enableUserRating;
    const ratingAnswerRequired = this.props.ratingAnswerRequired;
    const gotoQACandidatePanel = this.props.gotoQACandidatePanel;
    const askQuestion = this.props.askQuestion;
    const generateAlert = this.props.generateAlert;
    const enableRatingReason = this.props.enableRatingReason;
    const ratingReasonMsg = this.props.ratingReasonMsg;
    const ratingReasons = this.props.ratingReasons;

    return (
      <div>
        <AnswerPanelTable
          question={question}
          result={result}
          logId={logId}
          cgId={cgId}
          gotoQACandidatePanel={gotoQACandidatePanel}
          askQuestion={askQuestion}
          generateAlert={generateAlert}
        />

        {enableUserRating && (
          <UserRatingButton
            question={question}
            result={result}
            logId={logId}
            cgId={cgId}
            enableRatingReason={enableRatingReason}
            ratingAnswerRequired={ratingAnswerRequired}
            ratingReasonMsg={ratingReasonMsg}
            ratingReasons={ratingReasons}
          />
        )}
      </div>
    );
  },

  componentDidMount: () => {
    if (isIE()) {
      resizeImg();
      $(window).on('resize', resizeImg);
    }
  }
});

/**
 * Resizes images in the specified table rows based on the available width.
 *
 * This function targets images in the 3rd and 4th rows of a table with the class 'table'.
 * It calculates the maximum allowable width for each image based on the width of a
 * container with the class 'jumbotron', subtracting specified padding and icon widths.
 *
 * The function ensures that images do not exceed the calculated maximum width,
 * and if the image's original width is smaller, it retains the original width.
 *
 * @function resizeImg
 */
function resizeImg() {
  const aWidth = 40;
  const iconWidth = 150;
  const padding = 20;
  $('.table tr')
    .eq(2)
    .find('img')
    .each(function () {
      let self = this;
      let $img = $(self);
      let imgObj = new Image();
      imgObj.onload = function () {
        // ソースの画像サイズがわかったあとの処理
        let imgWidth = this.width;
        if (this.paramWidth) {
          imgWidth = this.paramWidth;
        }

        let maxWidth = $('.jumbotron').outerWidth() - aWidth - iconWidth - padding;
        if (imgWidth > maxWidth) {
          this.target.width(maxWidth);
        } else if (this.target.width() < imgWidth) {
          this.target.width(imgWidth);
        }
      };
      imgObj.src = $img.attr('src');
      imgObj.target = $img;
      imgObj.paramWidth = $img.attr('width');
    });
  $('.table tr')
    .eq(3)
    .find('img')
    .each(function () {
      const self = this;
      const $img = $(self);
      const imgObj = new Image();
      imgObj.onload = function () {
        // ソースの画像サイズがわかったあとの処理
        let imgWidth = this.width;
        if (this.paramWidth) {
          imgWidth = this.paramWidth;
        }

        const maxWidth = $('.jumbotron').outerWidth() - aWidth - padding;
        if (imgWidth > maxWidth) {
          this.target.width(maxWidth);
        } else if (this.target.width() < imgWidth) {
          this.target.width(imgWidth);
        }
      };
      imgObj.src = $img.attr('src');
      imgObj.target = $img;
      imgObj.paramWidth = $img.attr('width');
    });
}

/**
 * ユーザーエージェントがIEかどうかを判定
 @returns {boolean} IEの場合はtrue、それ以外はfalse
 */
function isIE() {
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/(msie|MSIE)/) || ua.match(/(T|t)rident/)) {
    return true;
  }
  return false;
}

export default AnswerPanel;
